import axios from "axios";

import * as types from 'types';

const url = "/user";

export const fetchUserData = () => axios.get(`${url}`);

// export const login = (credentials: types.StringObject) => axios.post(`${url}/login`, credentials);
